/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class ServicerTransferQuerySearchCriteria {
  servicerNumberFrom?: Array<string>;
  servicerNumberFromUI?: string;
  servicerNumberTo?: string;
  effectiveDateFrom?: string;
  effectiveDateTo?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  transactionStatusList?: Array<string>;
  sortBy?: number;
  fromServicerNumberList?: Array<string>;
  toServicerNumberList?: Array<string>;
}
